import capitalize from './capitalize';
import { isNotEmptyOrNull, stringValueCheck } from './utils';

export default (address: {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    postalCode?: string;
    town?: string;
}): [string, string, string] => {
    const addressText = [
        capitalize(address.addressLine1),
        capitalize(address.addressLine2),
        capitalize(address.addressLine3),
    ]
        .filter(isNotEmptyOrNull)
        .join(', ');
    const town = stringValueCheck(capitalize(address.town));
    const postalCode = stringValueCheck(capitalize(address.postalCode));
    return [addressText, town, postalCode];
};
